
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/enter-flow-order-summary",
      function () {
        return require("private-next-pages/design-system/enter-flow-order-summary.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/enter-flow-order-summary"])
      });
    }
  